class ProductgridLayout extends HTMLElement {
  constructor() {
    super();

    this.layoutSwitchers = this.querySelectorAll('[data-layout]');
    const productGrid = document.getElementById('product-grid');

    // Check if any switcher already has the 'active' class
    let activeSwitcher = Array.from(this.layoutSwitchers).find(switcher => switcher.classList.contains('active'));

    // If no switcher is initially active, set the first one as active
    if (!activeSwitcher && this.layoutSwitchers.length > 0) {
      activeSwitcher = this.layoutSwitchers[1];
      activeSwitcher.classList.add('active');

      // Initialize the product grid layout based on the first switcher
      const layout = activeSwitcher.getAttribute('data-layout');
      if (layout === 'grid') {
        productGrid.classList.add('grid--2-col-tablet-down', 'grid--3-col-desktop');
        productGrid.classList.remove('grid--1-col');
      } else if (layout === 'list') {
        productGrid.classList.remove('grid--2-col-tablet-down', 'grid--3-col-desktop');
        productGrid.classList.add('grid--1-col');
      }
    }

    // Add click event listeners to each switcher
    this.layoutSwitchers.forEach((switcher) => {
      switcher.addEventListener('click', () => {
        const layout = switcher.getAttribute('data-layout');

        // Update the product grid classes based on the selected layout
        if (layout === 'grid') {
          productGrid.classList.add('grid--2-col-tablet-down', 'grid--3-col-desktop');
          productGrid.classList.remove('grid--1-col');
        } else if (layout === 'list') {
          productGrid.classList.remove('grid--2-col-tablet-down', 'grid--3-col-desktop');
          productGrid.classList.add('grid--1-col');
        }

        // Remove the active class from all layout switchers
        this.layoutSwitchers.forEach((switcher) => {
          switcher.classList.remove('active');
        });

        // Add the active class to the clicked switcher
        switcher.classList.add('active');
      });
    });
  }
}

customElements.define('productgrid-layout', ProductgridLayout);